// Microsoft Bookings Popup Utility
const MICROSOFT_BOOKINGS_URL = "https://outlook.office.com/bookwithme/user/fbf764a9bb5b4c9793065cc702e3b5e6%40getcare360.com.au/meetingtype/sFYthDfSHkCSVKjlKsBDsA2?anonymous&ismsaljsauthenabled";

export const openBookingPopup = (customUrl = null) => {
  const url = customUrl || MICROSOFT_BOOKINGS_URL;
  const width = 600;
  const height = 700;
  const left = (window.screen.width - width) / 2;
  const top = (window.screen.height - height) / 2;
  
  window.open(
    url,
    'MicrosoftBookings',
    `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
  );
};

export default openBookingPopup;
